import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-simple-table-modal',
  templateUrl: './simple-table-modal.component.html',
  styleUrls: ['./simple-table-modal.component.scss']
})
export class SimpleTableModalComponent {
  @Output() export = new EventEmitter<string>();

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,) { }

  onExport() {
    this.export.emit(this.data.export);
  }
}
